import { Input } from "common/InputForm";
import useButtonLoader from "hooks/useButtonLoader";
import { CustomButton } from "components/form";
import React, { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { forgetApi, updatePasswordApi, verifyForgotPasswordApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import { auth } from "validation/schema/auth";
import { ValidateInput } from "validation";

const UpdatePassword = ({ data, setData, setSteps, userId }) => {
    const [buttonLoader, setButtonLoader] = useButtonLoader("Reset Password");
    const [error, setError] = useState("");

    // Input Validtion
    const validation = () => {
        const { errors, status } = ValidateInput(
            data,
            "updatePasswordSchema",
            auth,
            null
        );
        setError(errors);
        return status;
    };

    // on change handler
    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    console.log({ userId });
    

    // Forget password handler
    const forgetPasswordHandler = async (e) => {
        e.preventDefault();
        if (validation()) {
            try {
                setButtonLoader(true);
                const { data: responseData, status } = await updatePasswordApi({...data, userId});
                if (status === 200) {
                    toastMessage(responseData?.message, "success", "forgotPassword");
                    setData({});
                    setSteps(1);
                }
            } catch (e) {
                console.log("error", e);
            } finally {
                setButtonLoader(false);
            }
        }
    };

    return (
        <>
            <div className="forgot_password">
                <div className="back_button">
                    <button
                        type="button"
                        onClick={() => {
                            setSteps(1);
                            setData({});
                        }}
                    >
                        <IoIosArrowBack /> Back to login
                    </button>
                </div>

                <div className="form_title">
                    <h2>Reset Password?</h2>
                    <p>
                        No worries, we've got you covered! Enter your email address below
                        and we'll send you a otp to reset your password.
                    </p>
                </div>
                <div className="form_field">
                    <Input
                        label="Password*"
                        placeholder="Enter Password"
                        name="password"
                        maxLength={25}
                        value={data.password}
                        onChange={onChangeHandler}
                        error={error?.password}
                        extraError={error?.password}
                    />
                </div>
                <div className="form_field">
                    <Input
                        label="Confirm Password*"
                        placeholder="Enter Confirm Password"
                        name="confirmPassword"
                        maxLength={25}
                        value={data.confirmPassword}
                        onChange={onChangeHandler}
                        error={error?.confirmPassword}
                        extraError={error?.confirmPassword}
                    />
                </div>
                <div className="button_wrap button_right">
                    <CustomButton
                        type="submit"
                        className="button w-100"
                        onClick={forgetPasswordHandler}
                        ref={buttonLoader}
                    >
                        Reset Password
                    </CustomButton>
                </div>
            </div>
        </>
    );
};

export default UpdatePassword;
